
export const root= {
  borderRadius: '40px',
  paddingX: '12px',
  paddingY: '12px',
  gap: '4px',
  transitionDuration: '{transition.duration}'
};

export const image = {
  width: '40px',
  height: '40px'
};

export const icon = {
  size: '18px'
};

export const removeIcon = {
  size: '40px',
  focusRing: {
    width: '{focus.ring.width}',
    style: '{focus.ring.style}',
    color: '{focus.ring.color}',
    offset: '{focus.ring.offset}',
    shadow: '{form.field.focus.ring.shadow}'
  }
};

export const colorScheme= {
  light: {
    root: {
      background: 'var(--white-100)',
      color: 'var(--active-100)'
    },
    icon: {
      color: 'var(--active-100)'
    },
    removeIcon: {
      color: 'var(--primary-blue-60)'
    }
  },
  dark: {
    root: {
      background: '{surface.800}',
      color: '{surface.0}'
    },
    icon: {
      color: '{surface.0}'
    },
    removeIcon: {
      color: '{surface.0}'
    }
  }
};

export default {
  root,
  image,
  icon,
  removeIcon,
  colorScheme
}